import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const themes = {
  dark: {
    bg: '#050505',
    bgSecondary: '#0f0f0f',
    bgTertiary: '#1a1a1a',
    text: '#ffffff',
    textSecondary: '#aaaaaa',
    accent: '#00d4ff',
    accentText: '#000000',
    border: '#00d4ff22',
    navBg: '#000000',
    heroBg: '#050505',
    cardBg: '#0f0f0f',
    cardBorder: '#00d4ff22',
    inputBg: '#1a1a1a',
    searchBg: '#1a1a1a',
  },
  light: {
    bg: '#e8f4fb',
    bgSecondary: '#f0f8fc',
    bgTertiary: '#ffffff',
    text: '#003d52',
    textSecondary: '#555555',
    accent: '#0099cc',
    accentText: '#ffffff',
    border: '#cce8f4',
    navBg: '#0099cc',
    heroBg: '#e8f4fb',
    cardBg: '#ffffff',
    cardBorder: '#cce8f4',
    inputBg: '#ffffff',
    searchBg: 'rgba(255,255,255,0.2)',
  }
};

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem('theme');
    if (saved) return saved;
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  });

  useEffect(() => {
    localStorage.setItem('theme', theme);
    document.body.className = theme;
    document.body.style.backgroundColor = themes[theme].bg;
    document.body.style.color = themes[theme].text;
  }, [theme]);

  const toggleTheme = () => setTheme(t => t === 'dark' ? 'light' : 'dark');

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, colors: themes[theme] }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);